
import { VBottomSheet } from "vuetify/lib";

export default VBottomSheet.extend({});
